function ButtonGroup(): any {
  return {
    MuiButtonGroup: {
      defaultProps: {
        disableRipple: true
      }
    }
  };
}

export { ButtonGroup };
